export class AT 
{
    id: number;
    url: string;
    data: string;
user : number; 
mime: string;
name: string
size: string;
refId: number; 
ticket: number;
}
